/**
 * Footer component with DSPas Dev Studio branding
 */
export default function Footer() {
    return (
        <footer className="bg-gray-50 border-t border-gray-200 py-6 mt-auto">
            <div className="container mx-auto px-4 text-center">
                <a
                    href="https://dspas.dev"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-gray-500 hover:text-gray-700 transition-colors"
                >
                    powered by DSPas Dev Studio
                </a>
            </div>
        </footer>
    )
}
